<div>
    <div class="flex justify-center text-center text-2xl">
        <h1 mat-dialog-title>{{utils.traslatei18n(data.title)}}</h1>
    </div>
    <strong>
        <p class="flex justify-center text-center text-lg">{{utils.traslatei18n(data.message)}}</p>
    </strong>
    <strong>
        <p class="flex justify-center text-center text-lg">{{utils.traslatei18n(data.subMessage)}}</p>
    </strong>
    <div class="flex flex-row justify-center items-center mt-5">
        <button mat-flat-button mat-dialog-close color="accent">{{utils.traslatei18n('Ok')}}</button>
    </div>
</div>